// extracted by mini-css-extract-plugin
module.exports = {"textCarouselSlide":"styles_textCarouselSlide__pW7Jn","numberTag":"styles_numberTag__kXo9d"};